import axios from '@fs/zion-axios'

/**
 * Read group invite information for a specific invite.
 * @param {*} groupId - The group's ID.
 * @param {*} inviteId - The invite ID generated for the email invitation.
 * @throws 400 - Invalid group id.
 * @throws 400 - Invalid invite id.
 * @throws 404 - Group not found.
 * @throws 404 - Group invite not found.
 * @throws 410 - Group is tombstoned.
 * @returns {Promise} Promise of axios.get
 */
export default function getInviteInformation(groupId, inviteId) {
  return axios.get(`/service/tree/tree-data/groups/${groupId}/invites/${inviteId}`).then((res) => res.data)
}
